import { IPersonaProps } from "@nuorder/components";

export enum ValidationState {
    Valid = 0,
    Warning = 1,
    Invalid = 2,
}
export interface ISharePersonaProps extends IPersonaProps {
    isValid: boolean;
    ValidationState?: ValidationState;
    data?: nuorder.merchant.v1.Member;
    text?: string;
    key?: string | number;
    primaryText?: string;
    secondaryText?: string;
}

interface MerchantConnection {
    _id: string;
    merchant_id: string;
}

export interface IContact {
    _id: string;
    email: string;
    name: string;
    account_type: string;
    merchant_connections: MerchantConnection[];
    created_on: string;
}
